import { useCallback, useEffect, useState } from "react";

const STORAGE_KEY = "venueboard_demoMode";
const EVENT_NAME = "venueboard:demoModeChange";

const read = () => {
  if (typeof window === "undefined") return false;
  return window.localStorage.getItem(STORAGE_KEY) === "1";
};

// localStorage-backed boolean shared across components in the same tab via a
// CustomEvent (storage events only fire in *other* tabs, not the one that wrote).
export function useDemoMode() {
  const [demoMode, setDemoModeState] = useState(read);

  useEffect(() => {
    const onCustom = (e) => setDemoModeState(Boolean(e.detail));
    const onStorage = (e) => {
      if (e.key === STORAGE_KEY) setDemoModeState(e.newValue === "1");
    };
    window.addEventListener(EVENT_NAME, onCustom);
    window.addEventListener("storage", onStorage);
    return () => {
      window.removeEventListener(EVENT_NAME, onCustom);
      window.removeEventListener("storage", onStorage);
    };
  }, []);

  const setDemoMode = useCallback((value) => {
    const next = Boolean(value);
    window.localStorage.setItem(STORAGE_KEY, next ? "1" : "0");
    window.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: next }));
    setDemoModeState(next);
  }, []);

  return [demoMode, setDemoMode];
}
